import ModalFlow from 'src/common/ModalFlow';
import { useClientsContext } from '../context/ClientsContext';
import FamilyDetailsModal from '../FamilyDetailsModal';
import { useCreateFamily } from '../hooks/useCreateFamily';
import AddContactsToFamilyModal from './AddContactsToFamily/AddContactsToFamilyModal';
import { InProgressFamily, payloadFromInProgressFamily } from './dataHelpers';
import DefineRelationshipsModal from './DefineRelationshipsModal';
import { MixpanelEvents } from 'src/tracking/mixpanel/MixpanelEvents';
import { Mixpanel } from 'src/tracking/mixpanel/Mixpanel';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { ApiError, ApiErrorCode } from 'src/error/ApiError';
import { useNavigate } from 'react-router';

export default function CreateFamilyFlow() {
  const { flow, close } = useClientsContext();
  const { createFamily } = useCreateFamily();
  const navigate = useNavigate();

  const opened = flow === 'create-family';
  if (!opened) {
    return null;
  }

  const handleCreateFamily = async (family: InProgressFamily) => {
    if (!family) {
      throw new Error('No family selected');
    }

    try {
      await createFamily(payloadFromInProgressFamily(family));
      Mixpanel.track(MixpanelEvents.FAMILY_CREATED);
      close();
      navigate(0);
    } catch (error) {
      const message = ApiError.isApiError(ApiErrorCode.CLIENT_ALREADY_IN_FAMILY, error)
        ? error.message
        : 'An error occurred while creating the family. Please try again.';

      notifyAndLogError('Failed to create family', message, error, { familyData: family });
    }
  };

  return (
    <ModalFlow<InProgressFamily>
      steps={[FamilyDetailsModal, AddContactsToFamilyModal, DefineRelationshipsModal]}
      onComplete={handleCreateFamily}
      onClose={close}
    />
  );
}
